export const ROUTES = {
  chatbots: '/chatbots',
  faqs: '/faqs',
  simulations: '/simulations',
  simulationsDetail: '/simulations/:id',
};
